module.exports = __webpack_public_path__ + "cc4cf20be4ccce4fd2ab72c4e69112a7.pdf";